var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUbrAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "ui ui-ubr_alert",
    viewBox: "0 0 80 80",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.4 57.4L49.2 13.1V13c-1.8-3.1-5-5-8.6-5-3.6 0-6.8 1.9-8.7 5.1L9.4 57.9c-1.4 3.1-1.1 6.7.7 9.5 1.8 2.9 5 4.6 8.4 4.6h44c3.5 0 6.7-1.8 8.5-4.8 1.9-3 2-6.7.4-9.8zm-3.8 7.7c-1.1 1.8-3 2.9-5.1 2.9h-44c-2.1 0-3.9-1-5-2.7-1.1-1.7-1.3-3.8-.5-5.6L35.3 15c1.1-1.9 3-3 5.2-3 2.1 0 4.1 1.1 5.2 3l22.2 44.3c.9 1.8.8 4-.3 5.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 27.9h-4V52h4V27.9zm0 28.1h-4v8h4v-8z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbrAlert);
export default __webpack_public_path__ + "static/media/ubr_alert.cb86b6a4267dd6a8bce2d4d540426ccf.svg";
export { ForwardRef as ReactComponent };